import { TTimeRangePreset } from '@/shared/components/ui/filters/time-range-filter/time-range-filter.types';

export const TIME_RANGE_QUERY_PARAM = 'creationTimestamp';
export const TIME_STAMP_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSSSSS';
export const TIME_RANGE_PRESET_SUFFIX = 'Preset';

export const TIME_RANGE_PRESETS: TTimeRangePreset[] = [
  { id: 'last_24_hours', subtract: { days: 1 } },
  { id: 'last_7_days', subtract: { days: 7 } },
  { id: 'last_30_days', subtract: { days: 30 } },
  { id: 'last_3_months', subtract: { months: 3 } },
];
